module.exports = __webpack_public_path__ + "img/logo-main.0f49b6f8.svg";